/* eslint-disable react/require-default-props */
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';

const Div = (props) => <div {...props} />;

export default Div;
